import { extractProperty } from "./extractProperty"

export const ALLOWED_FONTS = ["Rag", "Assistant", "Heebo", "Open Sans", "Noto Sans"] as const
export type AllowedFont = (typeof ALLOWED_FONTS)[number]

export type ColorPackage = {
  backgroundColor: string
  textColor: string
  headingColor: string
}

export type CmsThemeData = {
  font: AllowedFont
  packages: [ColorPackage, ColorPackage, ColorPackage]
}

const DEFAULT_PACKAGE: ColorPackage = {
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  headingColor: "#000000",
}

const DEFAULT_FONT: AllowedFont = "Rag"

function extractColorPackage(pageData: any, index: number): ColorPackage {
  return {
    backgroundColor:
      extractProperty(pageData, `colorPackage${index}Background`) || DEFAULT_PACKAGE.backgroundColor,
    textColor: extractProperty(pageData, `colorPackage${index}Text`) || DEFAULT_PACKAGE.textColor,
    headingColor:
      extractProperty(pageData, `colorPackage${index}Heading`) || DEFAULT_PACKAGE.headingColor,
  }
}

export function extractThemeData(pageData: any): CmsThemeData {
  const rawFont = extractProperty(pageData, "pageFont") || DEFAULT_FONT
  const font: AllowedFont = ALLOWED_FONTS.includes(rawFont) ? rawFont : DEFAULT_FONT

  return {
    font,
    packages: [
      extractColorPackage(pageData, 1),
      extractColorPackage(pageData, 2),
      extractColorPackage(pageData, 3),
    ],
  }
}
